import { AxiosResponse } from 'axios';

import { instance as axios } from '../../api/axios';
import { LocationDto } from './interfaces';

export class LocationService {
  public static async getLocations(params: any) {
    try {
      const url = '/Location';
      const response: AxiosResponse<LocationDto[]> = await axios.get(url, params);

      return response.data;
    } catch (error: any) {
      throw new Error(error);
    }
  }
}
